<template>
	<div class="hours-con container" v-wechat-title="title">
    <div class="car-activity">
        <van-row class="car-activity-content" :style="bgColor">
            <van-col span="24" class="car-activity-msg" v-html="activityInfo.content"></van-col>

            <van-col span="24" class="list" v-for="(item, index) in activityInfo.cars" :key="index">
                <div class="box">
                	<img :src="item.image" @error="defaultPro()"/>
                	<p class="name">{{item.name}}</p>
                	<span class="price"><span>{{item.price[0]}}.</span>{{item.price[1]}}万</span>
                	<span class="btn" :style="btnColor" @click="carDetail_1(item)">立即购买</span>
                </div>
            </van-col>
            <van-col span="24" class="footer" :style="footerstyle">
            	<div>
	            	<van-divider :style="{ color: '#fff', borderColor: '#fff', padding: '0 8px' }">
					  别拉了，小巴也是有底线的
					</van-divider>
            	</div>
            </van-col>
		</van-row>
    </div>
    </div>
</template>

<script>
import productDefault from "@/assets/common/preload.png";
export default {
    data() {
        return {
        	title: '',
            activityInfo: {},
            footerstyle:{
		      paddingLeft: (document.body.clientWidth - 280) / 2 + 'px'
		    },
		    bgColor:{
		      background: ''
		    },
		    btnColor:{
		      background: '',
		      color: ''
		    },
		    purchase: {}
        };
    },
    created() {
//      this.$api.setToken(this.$route.query.token);
		this.$api.setToken();
//			localStorage.removeItem('_token');
    },
    mounted() {
    	this.getInfo();
        //window.addEventListener("scroll", this.handleScroll);
    },
    methods: {
        getInfo() {
            var ID = this.$route.query.id;
            this.$api
                .get("/car/index/index-ad/detail", { id: ID })
                .then(res => {
                    for(let i in res.cars) {
                    	res.cars[i].price = this.tranform(res.cars[i].price);
                    }
                    this.activityInfo = res;
        			this.title = res.title;
        			res.page_background_color = res.page_background_color || '#eeeeef';
        			res.button_background_color = res.button_background_color || '#ffff00';
        			res.button_fore_color = res.button_fore_color || '#ffffff';
        			this.bgColor = {background: res.page_background_color};
        			this.btnColor = {background: res.button_background_color, color: res.button_fore_color};
                });
        },
        carDetail_1(item) {
        	this.purchase = {
        		id: item.id,
        		thumb: item.image,
        		name: item.name
        	};
        	this.carDetail();
        },
        carDetail() {
        	this.params(JSON.stringify(this.purchase), JSON.stringify(this.purchase), 'carDetail');
        },
        tranform(data) {
	  		if(data != null && data != 0) {
	  			data = (Math.ceil(Number(data) / 100) / 100).toFixed(2) + '';
	  			let arr = [data.split('.')[0], data.split('.')[1]];
	  			return arr;
		    }else {
		    	return [0, '00']
		    }
	  	},
        defaultPro() {
            var img = event.srcElement;
            img.src = productDefault;
            img.onerror = null; //防止闪图
        }
    }
};
</script>

<style lang="less">
.car-activity {
    height: 100%;
	overflow-y: scroll;
    -webkit-overflow-scrolling:touch;
    .car-activity-content {
        .car-activity-msg {
	        width: 100% !important;
	        img {
	            width: 100% !important;
	            display: block;
	            height: auto !important;
	        }
            
        }
        .list {
            padding: 12px 12px 0;
            .box {
            	background: #fff;
            	border-radius: 6px;
            	height: 90px;
            	padding: 12px;
            	position: relative;
            	img {
            		width: 120px;
            		height: 88px;
            		float: left;
            	}
            	.name {
            		color: #333;
            		font-size: 15px;
            		padding-left: 12px;
            		line-height: 21px;
            		height: 42px;
            		overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					white-space: normal;
            	}
            	.price {
            		color: #F2301D;
            		font-size: 14px;
            		padding: 27px 0 0 12px;
            		display: inline-block;
            		span {
            			font-size: 18px;
            		}
            	}
            	.btn {
            		font-size: 16px;
            		width: 88px;
            		height: 32px;
            		line-height: 32px;
            		text-align: center;
            		display: inline-block;
            		position: absolute;
            		right: 12px;
            		bottom: 12px;
            		border-radius: 3px;
            	}
            }
        }
        .footer {
        	height: 48px;
        	line-height: 48px;
        	text-align: center;
        	color: #fff;
        	font-size: 13px;
        	div {
        		width: 280px;
        		overflow: hidden;
        		margin: 0;
        		line-height: 48px;
        		.van-divider--content-center::before, .van-divider--content-left::before, .van-divider--content-right::before {
        			margin-right: 8px;
        		}
        		.van-divider--content-center::after, .van-divider--content-left::after, .van-divider--content-right::after {
        			margin-left: 8px;
        		}
        	}
        }
    }
}
</style>
